import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  noIndex?: boolean;
  schemaJson?: string;
  preloadImage?: string;
}

export default function SEOHead({
  title,
  description,
  canonical,
  ogImage,
  noIndex,
  schemaJson,
  preloadImage,
}: SEOHeadProps) {
  const siteName = "Danu Marketing";
  const fullTitle = title.includes(siteName) ? title : `${title} | ${siteName}`;
  const defaultOgImage = "https://vibe.filesafe.space/1779537497488192178/assets/da8a0ee4-e313-47af-b196-a2f698248cef.png";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {preloadImage && <link rel="preload" as="image" href={preloadImage} fetchPriority="high" />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage || defaultOgImage} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage || defaultOgImage} />
      
      {/* Canonical */}
      {canonical && <link rel="canonical" href={`https://thedanumarketing.com${canonical}`} />}
      
      {/* Robots */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Schema */}
      {schemaJson && (
        <script type="application/ld+json">
          {schemaJson}
        </script>
      )}
    </Helmet>
  );
}
